import * as React from 'react';
const IpertensioneIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <path
      d="M74.57 111.29c3.33 3.18.18.19 3.64 3.22 6.5 5.7 13.01 11.4 19.62 16.98 2.51 2.12 1.83 2.15 4.39-.07 9.98-8.66 19.98-17.31 29.74-26.21 10.13-9.24 9.6-24.67-1-33.36-7.17-5.87-17.85-7.14-26.13-.38-1.79 1.46-5.25 4.54-5.25 4.54-.08-.1-.31-.39-.52-.65-5.33-6.34-11.92-9.7-20.34-7.98-8.72 1.78-14.58 7.05-17.01 15.61-1.15 4.04-1.24 7.84-.35 11.38"
      style={{
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
        stroke: primaryColor || '#282828',
      }}
    />
    <path
      d="M55.32 101.36H78.4l3.79-17.78 6.38 29.07 4.97-11.29h10.53"
      style={{
        stroke: secondaryColor || '#ffcf38',
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
      }}
    />
  </svg>
);
export default IpertensioneIcon;
